// extracted by mini-css-extract-plugin
export default {"radio":"RejectModalView_radio__ZUdAx","feedback":"RejectModalView_feedback__R0ZU2"};